document.addEventListener("DOMContentLoaded", function() {
    const dropdownToggles = document.querySelectorAll(".js-dropdown-toggle");
    if( dropdownToggles.length === 0 ) return;

    dropdownToggles.forEach(function(button) {
        // Prevent the link click from toggling the dropdown
        const link = button.querySelector('a');
        if( link ) {
            link.addEventListener("click", function(e) {
                e.stopPropagation();
            });
        }

        // Toggle dropdown on button click
        button.addEventListener("click", function() {
            this.classList.toggle("is-open");
        });
    });
});
